import * as React from "react";

export const NutritionVitaminB12KeyContent = () => (
  <>
    <g id="key">
      <rect width={1024} height={212} fill="white" />
      <g id="Container">
        <g id="key-item - Gene">
          <rect x={40.5} y={28.5} width={386.748} height={183} stroke="#818181" />
          <text
            id="gene-label"
            fill="#1A1A1A"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Bold"
            fontSize={12}
            letterSpacing="2.8px"
          >
            <tspan x={52.4383} y={48.4}>
              GENETICS
            </tspan>
          </text>
          <g id="Container_2">
            <g id="Container_3">
              <g id="Container_4">
                <g id="Component 2">
                  <g id="gene-lozenge">
                    <path
                      d="M56 58.3896H72C73.9941 58.3896 75.6104 60.0059 75.6104 62V78C75.6104 79.9941 73.9941 81.6104 72 81.6104H56C54.0059 81.6104 52.3896 79.9941 52.3896 78V62C52.3896 60.0059 54.0059 58.3896 56 58.3896Z"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M56 58.3896H72C73.9941 58.3896 75.6104 60.0059 75.6104 62V78C75.6104 79.9941 73.9941 81.6104 72 81.6104H56C54.0059 81.6104 52.3896 79.9941 52.3896 78V62C52.3896 60.0059 54.0059 58.3896 56 58.3896Z"
                      stroke="#1A1A1A"
                      strokeWidth={0.778643}
                    />
                  </g>
                </g>
                <text
                  id="Description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.0723} y={74.767}>
                    Not included in panel
                  </tspan>
                </text>
              </g>
              <g id="Container_5">
                <g id="Component 2_2">
                  <g id="gene-lozenge_2">
                    <path
                      d="M52 90C52 87.7909 53.7909 86 56 86H72C74.2091 86 76 87.7909 76 90V106C76 108.209 74.2091 110 72 110H56C53.7909 110 52 108.209 52 106V90Z"
                      fill="#CCBAFF"
                    />
                  </g>
                </g>
                <text
                  id="Description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2559} y={102.767}>
                    No read
                  </tspan>
                </text>
              </g>
              <g id="Container_6">
                <g id="Component 2_3">
                  <g id="snp-indicator">
                    <path
                      id="Polygon 3"
                      d="M63.3387 120.372C63.6326 119.876 64.3674 119.876 64.6613 120.372L70.8966 130.885C71.1905 131.381 70.8231 132 70.2352 132H57.7648C57.1769 132 56.8095 131.381 57.1034 130.885L63.3387 120.372Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.1738} y={130.767}>
                    Increased activity
                  </tspan>
                </text>
              </g>
              <g id="Container_7">
                <g id="Component 2_4">
                  <g id="snp-indicator_2">
                    <path
                      id="Polygon 3_2"
                      d="M64.6613 159.628C64.3674 160.124 63.6326 160.124 63.3387 159.628L57.1034 149.115C56.8095 148.619 57.1769 148 57.7648 148L70.2352 148C70.8231 148 71.1905 148.619 70.8966 149.115L64.6613 159.628Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_4"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2285} y={158.767}>
                    Decreased activity
                  </tspan>
                </text>
              </g>
            </g>
            <g id="Container_8">
              <g id="Container_9">
                <g id="Component 2_5">
                  <g id="gene-lozenge_3">
                    <path
                      d="M237 62C237 59.7909 238.791 58 241 58H257C259.209 58 261 59.7909 261 62V78C261 80.2091 259.209 82 257 82H241C238.791 82 237 80.2091 237 78V62Z"
                      fill="#00BF86"
                    />
                  </g>
                </g>
                <text
                  id="Risk description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.288} y={74.767}>
                    0 risk alleles
                  </tspan>
                </text>
              </g>
              <g id="Container_10">
                <g id="Component 2_6">
                  <g id="gene-lozenge_4">
                    <path
                      d="M237 90C237 87.7909 238.791 86 241 86H257C259.209 86 261 87.7909 261 90V106C261 108.209 259.209 110 257 110H241C238.791 110 237 108.209 237 106V90Z"
                      fill="#FF905F"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.271} y={102.767}>
                    1 risk allele
                  </tspan>
                </text>
              </g>
              <g id="Container_11">
                <g id="Component 2_7">
                  <g id="gene-lozenge_5">
                    <path
                      d="M237 118C237 115.791 238.791 114 241 114H257C259.209 114 261 115.791 261 118V134C261 136.209 259.209 138 257 138H241C238.791 138 237 136.209 237 134V118Z"
                      fill="#FF5D6D"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.006} y={130.767}>
                    2 risk alleles
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="key-item - Not included">
            <g id="Icon">
              <path
                id="*"
                d="M63.7483 186.79V189.209L59.8178 189.08L62.0638 192.319L59.861 193.615L57.8741 190.116L55.8873 193.615L53.6845 192.319L55.9305 189.08L52 189.209L52 186.79L55.9305 186.92L53.6845 183.681L55.8873 182.385L57.8741 185.883L59.861 182.385L62.0638 183.681L59.8178 186.92L63.7483 186.79Z"
                fill="black"
              />
            </g>
            <text
              id="Explanation"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={73.7483} y={192.086}>
                Limited / insufficient evidence for interpretation in this context
              </tspan>
            </text>
          </g>
        </g>
        <g id="Container_12">
          <g id="key-item - vitamin">
            <g id="Vitamin-Mineral">
              <g id="diamond">
                <path
                  id="Vector"
                  d="M481.126 28.9375L505.126 52.9375L481.126 76.9375L457.126 52.9375L481.126 28.9375Z"
                  stroke="#1A1A1A"
                />
              </g>
            </g>
            <text
              id="Vitamin description"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={517.218} y={57.767}>
                Vitamin / Mineral
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </>
);

const SvgNutritionVitaminB12Key = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={212}
    viewBox="0 0 1024 212"
    fill="none"
    {...props}
  >
    <NutritionVitaminB12KeyContent />
  </svg>
);

export default SvgNutritionVitaminB12Key;
